export default __webpack_public_path__ + "img/MYMY-logo-black.15753375a36f076796956c287912edda.png";